import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class MeshlabService {

    constructor(
        private http: HttpClient
    ) { }

    process(path: string) {

        let bucket = path.includes('wikyscan-2021-dev') ? 'wikyscan-2021-dev' : 'wikyscan-2021';


        path = path.split("amazonaws.com/")[1];
        let plyFile = path.replace('_processed.stl', '.ply');

        return this.http.post('http://35.157.158.77/convert',
            {
                bucket,
                multiply: 1000,
                path: plyFile,
                closeHoles: false,
                removeSmallParts: false
            })
    }

    blenderSkeleton() {
        return this.http.get('http://localhost:8094/', {})
    }


}
